module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'QcxjStationBind',
        'query': {}
      }),
      expression: "{name:'QcxjStationBind','query':{ }}"
    }],
    attrs: {
      "title": "已有考级中心/考级点",
      "label": "单位已在CCA官网申请注册过的考级中心/考级点，请请点击这里绑定。"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("去绑定")])]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'QcxjStationApply',
        'query': {}
      }),
      expression: "{name:'QcxjStationApply','query':{ }}"
    }],
    attrs: {
      "title": "新增考级中心/考级点",
      "label": "还尚未在CCA官网备案，请点击这里提交注册信息"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("新增注册")])]
      },
      proxy: true
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6077626d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/StationCert.vue
// module id = 2432
// module chunks = 0